import DashboardIcon from "@mui/icons-material/Dashboard";
import StoreIcon from "@mui/icons-material/Store";

let userMenu = [
    { name: "DashBoard", key: "DashBoard", icon: <DashboardIcon /> },
    { name: "Upload", key: "Upload", icon: <StoreIcon /> },
];



export { userMenu }